// https://drive.google.com/drive/u/0/folders/1jBKThGU4kbepDloCV0dCcfKhyagBVQPy

import {
  createTheme,
  Palette,
  responsiveFontSizes,
  Theme,
  ThemeOptions,
} from '@mui/material';
import components from 'theme/components';

export const fontFamily = [
  'ui-sans-serif',
  'system-ui',
  '-apple-system',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Roboto',
  'Helvetica Neue',
  'Arial',
  'Noto San',
  'sans-serif',
  'Apple Color Emoji',
  'Segoe UI Emoji',
  'Segoe UI Symbol',
  'Noto Color Emoji',
].join(',');

const options = {
  components: components,
  typography: {
    fontFamily: fontFamily,
    fontWeightSemiBold: 600,
    kampus: {
      fontFamily: fontFamily,
      fontWeight: 300,
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
      letterSpacing: '0.1rem',
      textTransform: 'uppercase',
    },
  },
} as ThemeOptions;

export const createThemeWithPalettes = (
  palette: Palette,
  darkPalette: Palette
): [Theme, Theme] => [
  responsiveFontSizes(
    createTheme({
      ...options,
      palette: palette,
    })
  ),
  responsiveFontSizes(
    createTheme({
      ...options,
      palette: darkPalette,
    })
  ),
];
